export default class Referral {
  /**
   *  @type {number}
  */
  id;

  /**
   *  @type {number}
  */
  officeId;;

  /**
   *  @type {number}
  */
  clientId;

  /**
   *  @type {string}
  */
  newClientSSN;

  /**
   *  @type {string}
  */
  newClientName;

  /**
   *  @type {number}
  */
 amount;

  /**
   *  @type {number}
  */
  status;

  /**
   *  @type {string}
  */
 statusReason;

  /**
   *  @type {number}
  */
  transactionId;

  /**
   *  @type {boolean}
  */
  overriden;

  /**
   *  @type {string}
  */
  dateAdded;

  constructor(opts = null) {
    if (opts != null) {
      if (opts.id != null) {
        this.id = opts.id;
      }
      if (opts.officeId != null) {
        this.officeId = opts.officeId;
      }
      if (opts.clientId != null) {
        this.clientId = opts.clientId;
      }
      if (opts.newClientSSN != null) {
        this.newClientSSN = opts.newClientSSN;
      }
      if (opts.newClientName != null) {
        this.newClientName = opts.newClientName;
      }
      if (opts.amount != null) {
        this.amount = opts.amount;
      }
      if (opts.status != null) {
        this.status = opts.status;
      }
      if (opts.statusReason != null) {
        this.statusReason = opts.statusReason;
      }
      if (opts.transactionId != null) {
        this.transactionId = opts.transactionId;
      }
      if (opts.overriden != null) {
        this.overriden = opts.overriden;
      }
      if (opts.dateAdded != null) {
        this.dateAdded = opts.dateAdded;
      }
    }
  }
}
